'use client';

import Script from 'next/script';

export function RedditPixel() {
  return (
    <Script
      strategy="lazyOnload"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: <reddit pixel>
      dangerouslySetInnerHTML={{
        __html: `
            <!-- Reddit Pixel -->
            !function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);rdt('init','a2_gj0l15xkjjiz');rdt('track', 'PageVisit');
            <!-- End Reddit Pixel -->
          `,
      }}
    />
  );
}

export const trackPayButtonClick = () => {
  if (window.rdt) {
    window.rdt('track', 'AddToCart');
  }
};
